// import Header from "./components/Header/Header";
// import Footer from "./components/Footer/Footer";
// import SideNav from "./components/SideNav/SideNav";
import React, { useState } from "react";
import Layout from "./components/Layout/Layout";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { Box, CssBaseline } from "@mui/material";
import SideNav from "./components/SideNav";
import Header from "./components/Header/Header";
import Login from "./components/Login/Login";
import ViewProperty from "./components/Home/viewPropertys";
import ViewProjectBody from "./components/Home/viewProject";
import AddPropertyModel from "./components/Home/addProperty";

import EditPropertyBody from "./components/Home/editProperty";

import SalePage from "./components/Home/sale";
import InvestorPage from "./components/Home/investorPage";
import InvestPayment from "./components/Home/investPayment";
import PaymentStatusPage from "./components/Home/paymentStatusPage";
import MarketPriceBody from "./components/Home/MarketUpdate";
import Message from "./components/Notification/Message";
import Notification from "./components/Notification/Notification";
import Property from "./components/Home/Property";
import AddDocument from "./components/Home/addDocument";
import KYPPage from "./components/Home/kypPage";
import BannerPage from "./components/Home/bannerPage";
import Setting from "./components/Home/settingpage";
import BannerDetails from "./components/Home/addbannerDetail";
import InvetorDetails from "./components/Home/investorDetail";
import ViewProject from "./components/Home/viewProjects";
import TeamPage from "./components/Home/teamPage";
import NewTeam from "./components/Home/newTeam";
import EditTeam from "./components/Home/editTeam";
import ProjectDocument from "./components/Home/projectaddDocument";
import GeneralPage from "./components/Home/generalPage";
import WalletPage from "./components/Home/wallet";
import WalletPaymentStatus from "./components/Home/walletPaymentstatus";
import SaleUpdatePage from "./components/Home/updateSale";
import Enquiry from "./components/report/enquiry";
import PropertyGrid from "./components/Home/approvePropertyGrid";
import ApproveProperty from "./components/Home/approveProperty";
import SiteVisit from "./components/Home/siteVisit";
import ApproveMarketUpdateGrid from "./components/Home/approveMarketUpdateGrid";
import ApproveMarketUpdate from "./components/Home/approveMarketUpdate";
import AddProjectModel from "./components/Home/addProject";
// import ViewProject from "./Pages/Project/viewProject";
// import "./styles/globals.scss";
import { useLocation } from "react-router-dom";
import ProfilePage from "./components/Header/ProfilePage";
import ApprovedProperty from "./components/legalteam/approvedPropertyGrid";
import { useSelector } from "react-redux";
import LegalTeamHeader from "./components/Header/LegalTeamHeader";
import LegalTeamApproveProperties from "./components/report/LegalteamApproveProperties";
import ApprovedMarketUpdateGrid from "./components/legalteam/ApprovedMarketUpdateGrid";
import SaleGrid from "./components/legalteam/SaleGrid";
import UpdateSaleByTeam from "./components/legalteam/UpdateSaleByTeam";
import WebsiteThemeColors from "./Pages/Settings/WebsiteThemeColors";
import PropertySaleShare from "./components/settings/PropertySaleShare";
import PropertyDocuments from "./Pages/Propertys/propertydocuments";
import UserListPage from "./components/Login/UserPage";
import { Navigate } from "react-router-dom";
import Notifications from "./components/Notification/Notification";
import NotificationDetail from "./components/Notification/NotificationDetail";
import AdminNotifications from "./components/Notification/AdminNotification";
import SubscriptionPlanForm from "./components/settings/addSubscriptionPlans";
import AdminDashboard from "./Pages/Dashboard/AdminDashboard";
import AddSubscriptionPlan from "./components/settings/addSubscriptionPlans";
import AddApartment from "./components/Home/addApartment";
import BookedProperties from "./components/report/BookedProperties";
import DocumentRequests from "./components/report/DocumentRequests";
import AddEditablePropertyDocuments from "./components/editableDocumentsUpload/addEditablePropertyDocuments";
import Apartment from "./components/Home/apartment";
import ViewApartments from "./components/projects/viewApartments";
import AddApartmentDocuments from "./components/projects/addApartmentDocuments";
import LegalTeamNotificationDetail from "./components/legalteam/Notification/LegalTeamNotificationDetails";
import AddImages from "./components/Home/AddImages";
import AddAdvertisement from "./components/Home/AddAdvertisement";
import DeleteAdvertisement from "./components/Home/DeleteAdvertisement";
import AddFAQ from "./components/FAQ/addFaq";
import FAQList from "./components/FAQ/FAQList";
import EditApartmentPlotsDetails from "./components/apartments/EditApartmentPlotDetails";
import EditVillaDetails from "./components/IndividualVilla/EditVillaDetails";
import UpdatePropertyPrice from "./components/IndividualVilla/UpdatePropertyPrice";
import ViewAllDocuments from "./components/common/ViewAllDocuments";
import ChangePassword from "./components/Login/ChangePasswordAdmin";
import ChangeUserDetails from "./components/Login/ChangeUserDetails";
import SubscriptionsTable from "./components/report/SubscriptionTable";
import MobileTheme from "./components/settings/MobileTheme";
import VendorSubscription from "./components/report/VendorSubscription";
import EditProject from "./components/projects/editProject";
import AddFlat from "./components/apartments/addFlat";
import AdminTerms from "./components/Footer/TermsAndConditions";
const drawerWidth = 240; // Sidebar width
const App = () => {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const role = useSelector((state) => state.user.role);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation(); 
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const noLayoutRoutes = ['/login'];
  const hideLayout = noLayoutRoutes.includes(location.pathname);
  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />

        {/* Only show SideNav if not hiding layout */}
        {!hideLayout && (
          <SideNav
            mobileOpen={mobileOpen}
            onDrawerToggle={handleDrawerToggle}
            drawerWidth={drawerWidth}
          />
        )}

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            marginLeft: !hideLayout ? { sm: `${drawerWidth}px` } : 0,
          }}
        >
          {/* Only show Header if not hiding layout */}
          {!hideLayout && (
            role === "legalteam" ? (
              <LegalTeamHeader onDrawerToggle={handleDrawerToggle} />
            ) : (
              <Header onDrawerToggle={handleDrawerToggle} />
            )
          )}
          {/* Add space below header */}
          {/* Page Content */}
          <Routes>
            <Route
              path="/"
              element={
                isAuthenticated && role === "admin" ? (
                  <Navigate to="/home" replace />
                ) : isAuthenticated && role === "legalteam" ? (
                  <Navigate to="/property/approvedPropertyGrid" replace />
                ) : (
                  <Navigate to="/login" replace />

                )
              }
            />

            <Route
              path="/home"
              element={
                // isAuthenticated ? <Home /> : <Navigate to="/" replace />
                isAuthenticated && role === "admin" ? <AdminDashboard /> : <Navigate to="/" replace />
              }
            />

            <Route path="/login" element={<Login />} />
            <Route path="/property" element={<Property />} />
            <Route path="/apartment" element={<Apartment />} />
            <Route path="/property/viewProperty" element={<ViewProperty />} />
            <Route path="/apartment/viewApartment" element={<ViewApartments />} />
            <Route path="/viewProject" element={<ViewProjectBody />} />
            <Route
              path="/property/addProperty"
              element={<AddPropertyModel />}
            />

            <Route
              path="/property/editProperty"
              element={<EditPropertyBody />}
            />
            <Route path="/property/addDocument" element={<AddDocument />} />
            <Route path="/investor/sale" element={<SalePage />} />
            <Route path="/investor/investorPage" element={<InvestorPage />} />
            <Route path="/investment/payment" element={<InvestPayment />} />
            <Route path="/investment/statusPage/:status" element={<PaymentStatusPage />} />
            <Route path="/kyp" element={<KYPPage />} />
            <Route path="/kyc/investorDetails" element={<InvetorDetails />} />
            <Route path="/property/marketPrice" element={<MarketPriceBody />} />


            <Route path="/message" element={<Message />} />
            <Route path="/notification" element={<Notification />} />
            <Route path="/viewProject/viewProject" element={<ViewProject />} />
            <Route path="/viewProject/addDocument" element={<ProjectDocument />} />
            <Route path="/viewApartment/addDocument" element={<AddApartmentDocuments />} />
            <Route path="/banner" element={<BannerPage />} />
            <Route path="/setting" element={<Setting />} />
            <Route path="/settings/themes" element={<Setting />} />
            <Route path="/settings/general" element={<GeneralPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/team/addTeam" element={<NewTeam />} />
            <Route path="/team/editTeam" element={<EditTeam />} />
            <Route path="/banner/bannerdetails" element={<BannerDetails />} />
            <Route path="/wallet" element={<WalletPage />} />
            <Route path="/wallet/statusPage/:status" element={<WalletPaymentStatus />} />
            <Route path="/investor/updateSale" element={<SaleUpdatePage />} />
            <Route path="/report/enquiries" element={<Enquiry />} />
            <Route path="/property/approvePropertyGrid" element={<PropertyGrid />} />
            <Route path="/property/approveProperty" element={<ApproveProperty />} />
            <Route path="/report/sitevisit" element={<SiteVisit />} />
            <Route path="/property/approvepriceupdateGrid" element={<ApproveMarketUpdateGrid />} />
            <Route path="/marketupdate/approve" element={<ApproveMarketUpdate />} />
            <Route path="/project/addProject" element={<AddProjectModel />} />
            <Route path="/ProfilePage" element={<ProfilePage />} />
            <Route path="/property/approvedPropertyGrid" element={<ApprovedProperty />} />
            <Route path="/legalteamapprovedproperties" element={<LegalTeamApproveProperties />} />
            <Route path="/property/approvedPriceUpdateGrid" element={<ApprovedMarketUpdateGrid />} />
            <Route path='/updatesaleGrid' element={<SaleGrid />} />
            <Route path='/legalteam/updatesale' element={<UpdateSaleByTeam />} />
            <Route path="/website/themecolors" element={<WebsiteThemeColors />} />
            <Route path="/setsharepercentage" element={<PropertySaleShare />} />
            <Route path="propertydocuments" element={<PropertyDocuments />} />
            <Route path="users" element={<UserListPage />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="notificationdetails" element={<NotificationDetail />} />
            <Route path="/admin-notifications" element={<AdminNotifications />} />
            <Route path='/addsubscriptionplans' element={<AddSubscriptionPlan />} />
            <Route path="/addApartment" element={<AddApartment />} />
            <Route path="/BookedProperties" element={<BookedProperties />} />
            <Route path="/DocumentRequests" element={<DocumentRequests />} />
            <Route path="/addEditableDocuments" element={<AddEditablePropertyDocuments />} />
            <Route path="/legalteamnotificationdetails" element={<LegalTeamNotificationDetail />} />
            <Route path="/admin/ SaleUpdatePage" element={<SaleUpdatePage />} />
            <Route path='/property/AddImages' element={<AddImages />} />
            <Route path="/admin/AddAdvertisement" element={<AddAdvertisement />} />
            <Route path="/admin/Advertisement" element={<DeleteAdvertisement />} />
            <Route path="/settings/addFAQ" element={<AddFAQ />} />
            <Route path="/settings/FAQList" element={<FAQList />} />
            <Route path="/apartment/editApartmentDetails" element={<EditApartmentPlotsDetails />} />
            <Route path="/villa/editVillaDetails" element={<EditVillaDetails />} />
            <Route path="/updatePropertyPrice" element={<UpdatePropertyPrice />} />
            <Route path="/documents/viewall" element={<ViewAllDocuments />} />
            <Route path="/user/changePassword" element={<ChangePassword />} />
            <Route path="/user/changeUserDetals" element={<ChangeUserDetails />} />
            <Route path="/admin/subscription" element={<SubscriptionsTable />} />
            {/* <Route path="vendor/subscription" element={<VendorSubscription/>}/> */}
            <Route path="/settings/MobileTheme" element={<MobileTheme />} />
            <Route path="/editProject" element={<EditProject/>} />
            <Route path="/addFlat" element={<AddFlat/>} />
            <Route path="/admin/pages" element={<AdminTerms/>}/>
          </Routes>
        </Box>
      </Box>
    </>
  );
};
export default App;


